import { isValidElement } from 'react';
import { fluidRange } from 'polished';
import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const Label = props => {
  const {
    svgIcon,
    color,
    label,
    testID
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(LabelContainer, {
      color: color,
      "data-testid": testID,
      children: [/*#__PURE__*/isValidElement(svgIcon) ? svgIcon : meta !== null && meta !== void 0 && meta.icons[svgIcon] ? /*#__PURE__*/jsx(SvgIcon, {
        type: svgIcon
      }) : null, /*#__PURE__*/jsx("span", {
        children: label
      })]
    })
  });
};
const LabelContainer = styled.div`
  ${_ref => {
  let {
    theme
  } = _ref;
  return fluidRange({
    prop: 'font-size',
    fromSize: '14px',
    toSize: '10px'
  }, `${theme.screen.xxs}`, `${theme.screen.xl}`);
}}

  align-items: center;
  justify-content: center;
  display: flex;
  max-width: fit-content;
  padding: 5px 12px;
  font-family: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fonts.InterRegular;
}};
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background-color: ${_ref3 => {
  let {
    color
  } = _ref3;
  return color;
}};
  border-radius: 48px;
  column-gap: 4px;

  svg {
    width: 14px;
    height: 14px;
  }
`;
Label.defaultProps = {
  svgIcon: undefined,
  label: '',
  color: meta.colors.gray[3],
  testID: undefined
};
Label.propTypes = {
  svgIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  color: PropTypes.string,
  label: PropTypes.string,
  testID: PropTypes.string
};
var Label$1 = Label;

export { Label$1 as default };
//# sourceMappingURL=Label.js.map
